class NavigationMobileUserProfile {
  constructor() {
    this.opened = false;
    this.triggers = document.querySelectorAll('.hdr-m-user-login-trigger');

    this.init();
  }

  init() {
    if (this.triggers) {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle();
        })
      })
    }
  }

  toggle() {
    if (this.opened === true) this.close();
    else this.open();
  }

  open() {
    this.opened = true;
    document.documentElement.classList.add('hdr-m-user-profile-open');
  }

  close() {
    this.opened = false;
    document.documentElement.classList.remove('hdr-m-user-profile-open');
  }
}

export default new NavigationMobileUserProfile();


// WEBPACK FOOTER //
// ./src/js/navigation-mobile-user-profile.js